import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import { PrivateRoute } from "./PrivateRoute";

import Login from "../src/components/Login/Login";
import Painel from "../src/components/Painel/Painel";
import Dashboard from "../src/components/Dashboard/Dashboard"; // Página inicial com quadros

// Institucional
import MesaDiretora from "../src/components/Institucional/MesaDiretora/MesaDiretora";
import BancadaParlamentares from "../src/components/Institucional/BancadaParlamentares/BancadaParlamentares";
import BlocosParlamentares from "../src/components/Institucional/BlocosParlamentares/BlocosParlamentares";
import Comissoes from "../src/components/Institucional/Comissoes/Comissoes";
import Frentes from "../src/components/Institucional/Frentes/Frentes";
import Parlamentares from "../src/components/Institucional/Parlamentares/Parlamentares";
import AudienciasPublicas from "../src/components/Institucional/AudienciasPublicas/AudienciasPublicas";

// Documentos Administrativos
import PesquisarDocumentos from "../src/components/DocumentosAdministrativos/PesquisarDocumentos/PesquisarDocumentos";

// Atividade Legislativa
import MateriasLegislativas from "../src/components/AtividadeLegislativa/MateriasLegislativas/MateriasLegislativas";
import PautasSessoes from "../src/components/AtividadeLegislativa/PautasSessoes/PautasSessoes";
import Relatorios from "../src/components/AtividadeLegislativa/Relatorios/Relatorios";
import SessoesPlenarias from "../src/components/AtividadeLegislativa/SessoesPlenarias/SessoesPlenarias";
import Votacao from "../src/components/AtividadeLegislativa/Votações/Votacao";

// Normas Jurídicas
import PesquisarNormas from "../src/components/NormasJuridicas/PesquisarNormas/PesquisarNormas";

import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";

const App = () => (
  <div className="react-app-container">
    <Router basename="/app">
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Painel com rotas aninhadas */}
          <Route
            path="/painel"
            element={
              <PrivateRoute roles={["administrator", "editor", "padrao"]}>
                <Painel />
              </PrivateRoute>
            }
          >
            {/* Dashboard/Início */}
            <Route index element={<Dashboard />} />

            {/* Institucional */}
            <Route
              path="institucional/mesa-diretora"
              element={<MesaDiretora />}
            />
            <Route
              path="institucional/bancada-parlamentares"
              element={<BancadaParlamentares />}
            />
            <Route
              path="institucional/blocos-parlamentares"
              element={<BlocosParlamentares />}
            />
            <Route path="institucional/comissoes" element={<Comissoes />} />
            <Route path="institucional/frentes" element={<Frentes />} />
            <Route
              path="institucional/parlamentares"
              element={<Parlamentares />}
            />
            <Route
              path="institucional/audiencias-publicas"
              element={<AudienciasPublicas />}
            />

            {/* Documentos Administrativos */}
            <Route
              path="documentos-administrativos/pesquisar"
              element={<PesquisarDocumentos />}
            />

            {/* Atividade Legislativa */}
            <Route
              path="atividade-legislativa/materias-legislativas"
              element={<MateriasLegislativas />}
            />

            {/* Votacao */}
            <Route
              path="atividade-legislativa/votacoes"
              element={<Votacao />}
            />

            {/* Pautas e Sessões com rotas separadas */}
            <Route path="atividade-legislativa/pautas-sessoes">
              <Route index element={<PautasSessoes />} />
            </Route>

            <Route
              path="atividade-legislativa/relatorios"
              element={<Relatorios />}
            />

            <Route path="atividade-legislativa/sessoes-plenarias">
              <Route index element={<SessoesPlenarias />} />
            </Route>

            {/* Normas Jurídicas */}
            <Route
              path="normas-juridicas/pesquisar"
              element={<PesquisarNormas />}
            />
          </Route>

          {/* Rota raiz */}
          <Route path="/" element={<Navigate to="/painel" replace />} />

          {/* Rota não encontrada */}
          <Route path="*" element={<Navigate to="/painel" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
